import { Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { BaseGuardChainFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: 'root'
})
export class NavigationControlGuard implements CanActivate {
  constructor(public baseGuardChainFacade: BaseGuardChainFacade) {
  }

  canActivate(next: ActivatedRouteSnapshot) {
    this.baseGuardChainFacade.requestSetActivatedRoute(next);
    return true
  }
}
